import { bubEvents } from 'shared/events/bub_events';

$(document).ready(() => {
  $('.sign-in-form > form').submit((e) => {
    bubEvents.track('Signing nav', 'Signed user in', {
      label: 'User email address',
      value: $('#user_email', e.currentTarget).val(),
    });
  });

  $('.token-form').submit(() => {
    bubEvents.track('Signing nav', 'Clicked link', {
      label: 'Send link',
      value: $('#magic-link-email-field').val(),
    });
  });

  $('.forgot-password-link').click(() => {
    bubEvents.track('Signing nav', 'Clicked link', {
      label: 'Forgot Password',
    });
  });

  $('.auth-link').click(e => {
    const authAction = $(e.currentTarget).data('authaction');
    const focusField = $(e.currentTarget).data('focus');

    $('.auth-form').addClass('hidden');
    $(`.${authAction}-form-wrapper`).removeClass('hidden');

    $('.checkout-auth-header').removeClass('selected');
    $(`#${authAction}-header`).addClass('selected');

    $(focusField).focus();
  });

  const $emailAlreadyExists = $('#account-already-exists-message');
  if ($emailAlreadyExists.length) {
    bubEvents.track('Signing nav', 'Viewed account exists message');
  }
});
